// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 0;
  margin: 0;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tour-consultant/consultant-overview/consultant-overview.page.scss"],"names":[],"mappings":"AAAA;EACC,UAAA;EACA,SAAA;EACA,cAAA;AACD","sourcesContent":[".container {\n\tpadding: 0;\n\tmargin: 0;\n\tdisplay: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
